import React, {
  useRef, useCallback, useEffect, useState,
} from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import ModalFactory from 'react-modal-promise';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { FormHandles } from '@unform/core';
import { Form as UForm } from '@unform/web';
import * as Yup from 'yup';
import { useToast } from 'hooks/toast';
import HeaderSimle from '../../../../components/Headers/Simple';
import getValidationError from '../../../../utils/getValidationsErros';
import { parseDate, removeAccents } from '../../../../utils';

/** hooks */
import { useAuth } from '../../../../hooks/auth';
import { useHttp } from '../../../../hooks/http';

/** components */
import Modal from '../../../../components/ModalSimple';
import {
  WrapperLabel, Input, InputMask, TextArea, Button, ButtonIcon,
} from '../../../../components/Forms';
import { InfoIcon, WarningIcon } from '../../../../styles/icons';
import {
  Container, GridButtons, WrapperBtnInfo, WrapperBtnCancel, WrapperBtnSubmit,
  WrapperModal, Red,Img
} from './styles';
import getCurrentPosition from 'utils/getCurrentPosition';

interface IForm {
  coord: {
    lat: number,
    lng: number
  }
}

const Detran: React.FC<IForm> = ({ coord }) => {
  const history = useHistory();
  const formRef = useRef<FormHandles>(null);
  const labelRef = useRef<HTMLLabelElement>(null);
  const labelConfRef = useRef<HTMLLabelElement>(null);
  const { user } = useAuth();
  const { addToast } = useToast();
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState<any>();
  const { httpGet, httpPost, unLoading, loading } = useHttp();
  const [btnLoading, setBtnLoading] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);

  useEffect(() => {
    unLoading();
  }, [unLoading, loading]);

  const handleGetPerson = useCallback(async () => {
    const document = formRef.current?.getFieldValue('document');
    const document_secondary = formRef.current?.getFieldValue('document_secondary');
    const name = formRef.current?.getFieldValue('name');
    const birthday = formRef.current?.getFieldValue('birthday');
    const mather = formRef.current?.getFieldValue('mather');
    
    const person = document_secondary || document
    ? { 
      document_secondary: document_secondary?.replace(/\D/g, ''),
      document: document?.replace(/\D/g, '')
     }
    : {
      name: removeAccents(name?.trim()),
      mather: removeAccents(mather?.trim()),
      birthday: parseDate(birthday),
    };

    let extendSchema;

    if (!person.document_secondary && !person.name) {
      if (!person.mather && !person.birthday) {
        extendSchema = {
          document_secondary: Yup.string().required('insira Rg ou Nome, Nascimento e Mãe.'),
        };
      }
    }

    let additionSchema;

    if (person.name || person.mather || person.birthday) {
      additionSchema = {
        name: Yup.string().required('insira Nome, Nascimento e Mãe.'),
        mather: Yup.string().required('insira a Mãe, Nome e Nascimento.'),
        birthday: Yup.string().required('insira o Nascimento, Nome e Mãe'),
      };
    }

    const schema = Yup.object().shape({
      mather: Yup.string(),
      ...additionSchema,
      ...extendSchema,
    });

    try {
      formRef.current?.setErrors({});
      await schema.validate(person, { abortEarly: false });

      setBtnLoading(true);
      const response: any = await httpGet('/orders/autocomplete/detran', { params: { ...person } });
    
      if (response.status === 200) {
        const { data } = response;
        setBtnLoading(false);

        if (data.MsgRetorno === 'Cidadão não encontrado'
          || data.MsgRetorno === 'Não existe solicitação de Processamento em aberto para este ID.') {
          addToast({ type: 'error', title: data.MsgRetorno });
        } else if (data?.RG !== 0) {
          setShowForm(false);
          setFormData(
            {
              document: data?.CPF, 
              document_secondary: data?.RG, 
              name: data?.NoCidadao,
              birthday: data?.DtNascimento,
              mather: data?.NoMaeCidadao,
              foto: `data:image/png;base64,${data?.fotoCivil?.string}`
            });
        
            formRef.current?.setData({
              ...data,
              document: data?.CPF, 
              document_secondary: data?.RG, 
              name: data?.NoCidadao,
              birthday: data?.DtNascimento,
              mather: data?.NoMaeCidadao,
              confirmed: [{ value: null, label: '' }],
            });
          labelConfRef.current?.click();
        } else {
          addToast({ title: data.MsgRetorno });
        }
      }

      setBtnLoading(false);
      if (response.status !== 200) {
        setBtnLoading(false);
      }
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const erros = getValidationError(err);
        formRef.current?.setErrors(erros);
      }

      setBtnLoading(false);
    }

  }, [coord, history]); // eslint-disable-line


  const handleChangeChecked = useCallback(async (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisableBtn(event.target.checked);
  }, []);

  const handleHover = useCallback(() => {
    setDisableBtn(false);
    labelConfRef.current?.click();
    formRef.current?.reset();
  }, []);

  const handleSubmit = useCallback(async (data: any) => {
      const personSubmit = {
        ...data,
        ...coord,
        name: data.name.toUpperCase(),
        mather: data.mather.toUpperCase(),
        birthday: parseDate(data.birthday),
        management_id: user?.allocation?.management_id,
        document: data.document?.replace(/\D/g, ''),
        document_secondary: data.document_secondary?.replace(/\D/g, ''),
        type: 'person',
      };

      setBtnLoading(true);
      const position = await getCurrentPosition();
      console.log("PP=> ",personSubmit, position)

      const response: any = await httpPost('orders', {
        ...personSubmit,
        current_lat: position.lat,
        current_lng: position.lng,
      });
      if (response.response?.status === 302) {
        const { data } = response.response;
        history.push(`/order/detail/${data.id}`);
      }
  
      if (response.status === 200) {
        history.push('/orders/latest');
      }
  
      if (response.status !== 200) {
        setBtnLoading(false);
      }
  
      setBtnLoading(false);

  },[coord, history, httpPost, user])

  return (
    <>
      <HeaderSimle>
        IDENTIFICAÇÃO CIVIL
      </HeaderSimle>
      <Container>
        <UForm ref={formRef} onSubmit={handleSubmit}>
          <Grid container spacing={1}>
            <WrapperLabel label="RG" xs={12} sm={6}>
              <Input name="document_secondary" type="tel" />
            </WrapperLabel>
            <WrapperLabel label="Cpf" xs={12} sm={6}>
              <Input name="document" type="tel" />
            </WrapperLabel>
            <WrapperLabel label="Nascimento" xs={12} sm={6}>
              <InputMask name="birthday" mask="99/99/9999" placeholder="DD/MM/YYYY" type="tel" />
            </WrapperLabel>
            <WrapperLabel label="Nome" xs={12}>
              <Input name="name" style={{ textTransform: 'uppercase' }} />
            </WrapperLabel>
            <WrapperLabel label="Mãe" xs={12}>
              <Input name="mather" style={{ textTransform: 'uppercase' }} />
            </WrapperLabel>
            <WrapperLabel label="Observação" xs={12}>
              <TextArea row={2} name="description" />
            </WrapperLabel>
          </Grid>

          <GridButtons>
            <WrapperBtnInfo>
              <ButtonIcon
                title="Instruções"
                onClick={() => labelRef.current?.click()}
              >
                <InfoIcon />
              </ButtonIcon>

              <label ref={labelRef} htmlFor="modal-instruction" />
              <Modal id="modal-instruction" width={520} height="auto">
                <h1>Instruções</h1><br />
                <p>
                  Para solicitar uma consulta de pessoa você precisa no mínimo
                  informar os seguintes dados:
                </p><br />
                <p><b>Nome e RG</b> ou</p>
                <p><b>Nome e Nascimento</b> ou</p>
                <p><b>Nome e Mãe</b> ou</p>
                <p><b>Nome e Pai</b>.</p>
                <br />
              </Modal>
            </WrapperBtnInfo>
            <WrapperBtnCancel>
              <Button
                type="button"
                onClick={() => { history.push('/dashboard'); }}
              >
                Cancelar
              </Button>
            </WrapperBtnCancel>
            <WrapperBtnSubmit>
              <Button
                type="button"
                onClick={() => {
                  if (showForm) {
                    formRef.current?.submitForm();
                  } else {
                    handleGetPerson();
                  }
                }}
                isLoading={btnLoading}
              >
                Consultar
              </Button>
            </WrapperBtnSubmit>
          </GridButtons>
        </UForm>
        <WrapperModal>
        <label ref={labelConfRef} htmlFor="modal-conf" />
        <Modal id="modal-conf" width={520} height="auto">
          <h2>
            <WarningIcon /> Confirma os dados da pessoa consultada ?
          </h2>
          {formData?.document_secondary && (
          <p>RG: <b>{formData?.document_secondary}</b></p>
          )}
          {formData?.document && (
          <p>Cpf: <b>{formData?.document}</b></p>
          )}
          {formData?.name && (
          <p>Nome: <b>{formData?.name}</b></p>    
          )}
          <p>Nascimento: <b>{formData?.birthday}</b></p>
          <p>Mãe: <b>{formData?.mather.toUpperCase()}</b></p>
          {formData?.foto && (
              <p><Img src={formData?.foto} width={100} height={120} /></p> 
          )}
          <FormControlLabel
            label={<Red>Confirmo as informações acima.</Red>}
            control={(
              <Switch
                onChange={handleChangeChecked}
                color="primary"
                name="checked"
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            )}
          />

          <span>
            <Button
              onClick={handleHover}
            >
              Cancelar
            </Button>
            <Button
              onClick={() => formRef.current?.submitForm()}
              isLoading={btnLoading}
              disableForce={!disableBtn}
            >
              Confirmar
            </Button>
          </span>

        </Modal>
      </WrapperModal>
      <ModalFactory />
      </Container>
    </>
  );
};

export default Detran;

